export default __webpack_public_path__ + "static/media/daniele-franchi-S9LN3vb47gw-unsplash.a0b9522f.jpg";